module.exports = __webpack_public_path__ + "static/media/johngilbert_resume_es.1a25d65c.jpg";